<template>
  <row>
    <!-- Details -->
    <component
      class="cell-in-row"
      :is="detailsComponent"
      :item="item"
      :affiliated-plans="affiliatedPlans"/>

    <!-- Preview -->
    <component
      class="cell-in-row"
      :is="previewComponent"
      :item="item"/>
  </row>
</template>

<script>
import Row from './utility/Row'
export default {
  name: 'Item',
  components: { Row },
  props: {
    item: {
      type: Object,
      required: true
    },
    affiliatedPlans: {
      type: Array,
      required: true
    },
    detailsComponent: {
      type: Function,
      required: true
    },
    previewComponent: {
      type: Function,
      required: true
    }
  }
}
</script>

<style scoped>
.cell-in-row {
  min-width: 24.5rem !important;
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
}
</style>
